import { Badge, Button, Table, Text } from '@elladx/design-system';
import { Link } from 'react-router-dom';
import type { OrderHistoryEntry } from '../../types';
import { getStatusBadgeClass, getStatusLabel } from '../../utils/orderStatus';
import { getEffectiveRefundStatus } from '../../utils/recentOrders';
import { formatDateTime } from '../../utils/dateFormat';
import { buildPrintPath } from '../../utils/labels';
import { friendlyServiceName } from '../../utils/shippingServices';
import { orderPostage } from './ShipmentDetailsModal';
interface OrdersTableProps {
    orders: OrderHistoryEntry[];
    onViewShipment: (order: OrderHistoryEntry) => void;
    onViewTracking: (order: OrderHistoryEntry) => void;
    onCancel: (order: OrderHistoryEntry) => void;
}
function OrdersTable({ orders, onViewShipment, onViewTracking, onCancel }: OrdersTableProps) {
    return (<div className="table-wrapper management-order-list">
      <Table>
        <thead><tr><th>Recipient</th><th>Postage</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>{orders.map(order => <tr key={order.record_key || order.shipment_id}>
          <td data-label="Recipient" className="management-order-recipient"><strong>{order.recipient || 'Unnamed recipient'}</strong><Text size="small" tone="muted">{friendlyServiceName({ carrier: order.carrier || '', service: order.service || '' })}{order.tracking_code ? ` · ${order.tracking_code}` : ''}</Text><Text size="small" tone="muted">{order.destination || 'Destination unavailable'} · {formatDateTime(order.created_at)}</Text></td>
          <td data-label="Postage" className="management-order-price">{orderPostage(order)}</td>
          <td data-label="Status"><Badge className={`status-badge ${getStatusBadgeClass(order)}`}>{getStatusLabel(order)}</Badge>{order.est_delivery_date && <Text size="small" tone="muted">Estimated {new Date(order.est_delivery_date).toLocaleDateString()}</Text>}</td>
          <td data-label="Actions"><div className="row-actions">
            <Button type="button" variant="primary" size="sm" onClick={() => onViewShipment(order)}>View shipment</Button>
            {order.tracking_code && <Button type="button" variant="secondary" size="sm" onClick={() => onViewTracking(order)}>Track</Button>}
            {order.label_url && <Button asChild variant="secondary" size="sm"><Link to={buildPrintPath(order.label_url, order.label_file_type)}>Print label</Link></Button>}
            {order.status === 'purchased' && !getEffectiveRefundStatus(order) && <Button type="button" variant="danger-secondary" size="sm" onClick={() => onCancel(order)}>Request refund</Button>}
          </div></td>
        </tr>)}</tbody>
      </Table>
    </div>);
}
export default OrdersTable;
